<template>
  <section>
    <!-- <a href="" target="_blank" rel="noopener noreferrer"><img src="/static//static/images/topguanggao.png" alt="" srcset="" class="topguanggao"></a>
    <Header :indexData="indexData" :userInfo="userInfo" :keyword="keyword"></Header>
 
    <Footer :indexData="indexData"></Footer>-->
    <div id="reg">
      <div class="header">
        <div class="container">
          <div class="logo">
            <a href="/">
              <img src="/static/images/logo.png" />
            </a>
          </div>
        </div>
      </div>
      <div class="container">
        <!-- <el-tabs v-model="type" >
          <el-tab-pane label="集团注册" name="3">集团注册</el-tab-pane>
          <el-tab-pane label="会员注册" name="1">会员注册</el-tab-pane>
          <el-tab-pane label="企业注册" name="2">企业注册</el-tab-pane>

        </el-tabs> -->
        <form action lay-filter="huiyuanReg" class="layui-form">
          <div class="regbox">
            <div style="position: absolute; right: 30px; top: 50px; font-size: 12px;">
              已有快力文账号？
              <router-link to="/login">
                <a href="javascript;," class="color-primary">立即登录</a>
              </router-link>
            </div>
            <div class="hd flex">
              <li @click="changeType('3')" :class="type=='3'?'active':''">集团注册</li>
              <li :class="type=='1'?'active':''" @click="changeType('1')">会员注册</li>
              <li @click="changeType('2')" :class="type=='2'?'active':''">企业注册</li>
            </div>
            <div class="bd">
              <div class="huiyuan" v-if="type=='1'">
                <div class="row">
                  <input
                    type="text"
                    placeholder="用户名"
                    name="username"
                    lay-verify="required"
                    class="layui-input"
                  />
                </div>
                <div class="row">
                  <input
                    type="password"
                    placeholder="设置你的登录密码"
                    name="pwd1"
                    lay-verify="required"
                    class="layui-input"
                  />
                </div>
                <div class="row">
                  <input
                    type="password"
                    placeholder="请再次输入你的密码"
                    name="pwd2"
                    lay-verify="required"
                    class="layui-input"
                  />
                </div>
                <div class="row">
                  <input
                    type="text"
                    maxlength="11"
                    placeholder="手机号码"
                    v-model="mobile"
                    name="mobile"
                    lay-verify="phone"
                    class="layui-input"
                  />
                </div>
                <div class="row">
                  <div class="fr">
                    <button
                      type="button"
                      :class="countdown>0 ? 'layui-btn layui-btn-disabled ' :'layui-btn regbtn'"
                      @click="getcode"
                    >{{countdown>0 ? countdown+"S后重新获取":"获取验证码"}}</button>
                  </div>
                  <div style="overflow: hidden;">
                    <input
                      type="text"
                      placeholder="短信验证码"
                      name="smscode"
                      lay-verify="required"
                      class="layui-input"
                    />
                  </div>
                </div>
              </div>
              <div class="huiyuan" v-else>
                <div class="row">
                  <input
                    type="text"
                    placeholder="公司名称"
                    name="title"
                    lay-verify="required"
                    class="layui-input"
                  />
                </div>
                <div class="row">
                  <input
                    type="text"
                    placeholder="联系人"
                    name="userreal"
                    lay-verify="required"
                    class="layui-input"
                  />
                </div>
                <div class="row">
                  <input
                    type="text"
                    placeholder="电话"
                    name="telephone"
                    lay-verify="required"
                    class="layui-input"
                  />
                </div>
                <div class="row">
                  <input
                    type="text"
                    placeholder="地址"
                    name="address"
                    lay-verify="required"
                    class="layui-input"
                  />
                </div>
                <div class="row">
                  <input
                    type="text"
                    placeholder="用户名称"
                    name="username"
                    lay-verify="required"
                    class="layui-input"
                  />
                </div>
                <div class="row">
                  <input
                    type="password"
                    placeholder="设置你的登录密码"
                    name="pwd1"
                    lay-verify="required"
                    class="layui-input"
                  />
                </div>
                <div class="row">
                  <input
                    type="password"
                    placeholder="请再次输入你的密码"
                    name="pwd2"
                    lay-verify="required"
                    class="layui-input"
                  />
                </div>
                <div class="row">
                  <input
                    type="text"
                    placeholder="请输入税号"
                    name="taxno"
                    lay-verify=""
                    class="layui-input"
                  />
                </div>
                <div class="row upload">
                  <div class="flex ju-be">
                    <span>上传头像或企业logo</span>
                    <el-upload
                      class="uploadimg"
                      :action="uploadimg"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccesslogo"
                      :before-upload="beforeAvatarUpload"
                      list-type="picture"
                    >
                      <el-button size="small" type="primary" class="primary_bg primary_bor">点击上传</el-button>
                    </el-upload>
                  </div>
                  <img :src="indexpic" alt />
                  <input type="hidden" v-model="indexpic" name="indexpic" />
                </div>
                <div class="row upload zhizhao">
                  <div class="flex ju-be">
                    <span>上传营业执照</span>
                    <el-upload
                      class="uploadimg"
                      :action="uploadimg"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccesszz"
                      :before-upload="beforeAvatarUpload"
                      list-type="picture"
                    >
                      <el-button size="small" type="primary" class="primary_bg primary_bor">点击上传</el-button>
                    </el-upload>
                  </div>
                  <img :src="cert" alt />
                  <input type="hidden" v-model="cert" name="cert" />
                </div>
              </div>
              <div class="row" style="font-size: 12px;">
                <el-checkbox v-model="checked" fill="#F19D15"></el-checkbox>
                <span class="color-primary shouzhi" @click="klwfl">《快力文网站服务条款》《法律声明和隐私权政策》</span>
              </div>
              <div style="margin-top: 30px;">
                <button
                  type="button"
                  lay-submit
                  lay-filter="huiyuanReg"
                  :class="!checked?'layui-btn layui-btn-disabled layui-btn-fluid' :'layui-btn layui-btn-fluid regbtn'"
                >注册</button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="container loginfooter">
        <div class="link">
          <span v-for="(item,index) in indexData.index_link_bottom" :key="index">
            <a :href="item.url">{{item.remark}}</a>
            {{index < indexData.index_link_bottom.length-1 ? "|" : ""}}
          </span>
        </div>
        <div class="mt10" v-html="indexData.index_copyright"></div>
      </div>
    </div>
    <el-dialog title="《快力文网站服务条款》《法律声明和隐私权政策》" :visible.sync="dialogTableVisible">
      <div v-html="klwflstr" class="xieyi"></div>
       <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogTableVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="dialogTableVisible = false;checked=true">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
import Header from "../components/header";
import Footer from "../components/footer";
export default {
  components: {
    Header,
    Footer
  },
  name: "login",
  data() {
    return {
      uploadimg: sessionStorage.baseUrl + "app/file/upload",
      mobile: "",
      oldUrl: "",
      dialogTableVisible: false,
      countdown: 0,
      indexpic: "",
      cert: "",
      indexData: {},
      klwflstr: "",
      type: "1",
      checked: false //是否勾选
    };
  },
  methods: {
    // changegou(checked) {
    //   this.checked = !checked;
    // },
    async klwfl() {
      this.dialogTableVisible = true;
      let klwflstr = await this.$fetch("index/protocal", {
        productid: 4281
      });
      this.klwflstr = klwflstr;
    },
    async someconfig() {
      let that = this;
      layui.use(["form", "layer"], function() {
        var form = layui.form;
        var layer = layui.layer;
        form.verify("huiyuanReg", {});
        form.on("submit(huiyuanReg)", async data => {
          let submitData = data.field;
          if (submitData.pwd1 != submitData.pwd2) {
            layer.alert("2次输入的密码不一致", { icon: 5 });
            return;
          }

          submitData["userpwd"] = submitData.pwd1;
          submitData["levelid"] = that.type;
          console.log("submitData", submitData);
          delete submitData.pwd1;
          delete submitData.pwd2;
          delete submitData.file;
          if (!submitData.mobile) {
            submitData["mobile"] = submitData.telephone;
          }
          // location.hash = "/login";
          // that.$router.push('/login')
          // return;
          // this.indexData =await that.$fetch("Index/indexdata");
          let res = await that.$fetch("login/register", {
            body: submitData
          });
          // console.log("result",result)
          // return;
          if (!res) return;
          layer.alert("注册成功", { icon: 1 });
          let result = await that.$fetch("login/login", {
            body: {
              username: submitData.username,
              userpwd: submitData.userpwd
            }
          });

          sessionStorage.guid = result.guid;
          localStorage.jinruser = JSON.stringify(result.user);
          sessionStorage.user = localStorage.jinruser;
          setCookie("guid", result.guid, 2);
          if (window.history.length <= 1 || that.oldUrl == "/login") {
            that.$router.push({ path: "/" });
            return false;
          } else {
            console.log("window.history", window.history);
            that.$router.go(-1);
          }
          // location.hash = "#/login";
          // sessionStorage.guid = result.guid;
          // localStorage.jinruser = JSON.stringify(result.user);
          // self.location = "index.html";
          // setCookie("guid", result.guid, 2);
        });
      });
    },
    changeType(type) {
      this.type = type;
    },
    async getcode() {
      let result = await this.$fetch("tool/sendsms", {
        body: { mobile: this.mobile }
      });
      if (result || result == 0) {
        this.disbled = false;
        let time = 59;
        let timeId = setInterval(() => {
          time--;
          this.countdown = time;
          if (time <= 0) {
            clearInterval("timeId");
          }
        }, 1000);
      }
    },
    handleAvatarSuccesszz(res, file) {
      if (res.code == 0) {
        this.cert = res.msg;
      } else {
        this.$message.error("上传失败，请稍后重试");
      }
    },
    handleAvatarSuccesslogo(res, file) {
      if (res.code == 0) {
        this.indexpic = res.msg;
      } else {
        this.$message.error("上传失败，请稍后重试");
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例,将值传入oldUrl
      vm.oldUrl = from.path;
    });
  },
  async mounted() {
    // console.log("window.history", window.history,this.oldUrl);
    //   console.log(this.$router.push('/login'))
    this.indexData = await this.$fetch("Index/indexdata");
    this.someconfig();
  }
};
</script>


<style lang='scss' scoped>
.layui-unselect {
  display: none !important;
}
.xieyi{
  max-height: 600px;
  overflow-y: auto;
}
.upload {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(179, 179, 179, 1);
  .flex {
    padding: 0 12px;
    width: 100%;
    box-sizing: border-box;
    margin: 10px 0;
    .uploadimg {
      width: 74px;
      height: 24px;
      background: rgba(241, 157, 21, 1);
      border-radius: 5px;
      box-sizing: border-box;
    }
  }
  img {
    width: 70px;
    height: 70px;
    background: rgba(245, 245, 246, 1);
    border-radius: 50%;
    margin-left: 12px;
  }
}
.zhizhao {
  img {
    width: 130px;
    height: 70px;
    background: rgba(245, 245, 246, 1);
    border-radius: 0%;
  }
}
.row {
  .layui-form-checkbox {
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/register.vue